__turbopack_context__.v({
  "button": "StoreCard-module-scss-module__CDdyRG__button",
  "buttonMobile": "StoreCard-module-scss-module__CDdyRG__buttonMobile",
  "directions": "StoreCard-module-scss-module__CDdyRG__directions" + " " + "StoreCard-module-scss-module__CDdyRG__hours",
  "hours": "StoreCard-module-scss-module__CDdyRG__hours" + " " + "StoreCard-module-scss-module__CDdyRG__text",
  "icon": "StoreCard-module-scss-module__CDdyRG__icon",
  "isActive": "StoreCard-module-scss-module__CDdyRG__isActive",
  "isFavourite": "StoreCard-module-scss-module__CDdyRG__isFavourite",
  "name": "StoreCard-module-scss-module__CDdyRG__name",
  "notice": "StoreCard-module-scss-module__CDdyRG__notice",
  "pdpButton": "StoreCard-module-scss-module__CDdyRG__pdpButton",
  "pdpSplit": "StoreCard-module-scss-module__CDdyRG__pdpSplit",
  "pdpStore": "StoreCard-module-scss-module__CDdyRG__pdpStore",
  "phone": "StoreCard-module-scss-module__CDdyRG__phone" + " " + "StoreCard-module-scss-module__CDdyRG__text",
  "set": "StoreCard-module-scss-module__CDdyRG__set",
  "setStoreButton": "StoreCard-module-scss-module__CDdyRG__setStoreButton",
  "split": "StoreCard-module-scss-module__CDdyRG__split",
  "splitBottom": "StoreCard-module-scss-module__CDdyRG__splitBottom" + " " + "StoreCard-module-scss-module__CDdyRG__split",
  "store": "StoreCard-module-scss-module__CDdyRG__store",
  "text": "StoreCard-module-scss-module__CDdyRG__text",
  "title": "StoreCard-module-scss-module__CDdyRG__title",
});
